'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBarStep = (_dec = (0, _reactCssModules2.default)(_style2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(ProgressBarStep, _React$Component);

  function ProgressBarStep() {
    (0, _classCallCheck3.default)(this, ProgressBarStep);
    return (0, _possibleConstructorReturn3.default)(this, (ProgressBarStep.__proto__ || (0, _getPrototypeOf2.default)(ProgressBarStep)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProgressBarStep, [{
    key: 'isCurrentStep',
    value: function isCurrentStep() {
      return this.props.currentStep === this.props.index;
    }
  }, {
    key: 'styleName',
    value: function styleName() {
      var baseStyle = 'a-checkoutStep';

      if (this.isCurrentStep()) {
        return baseStyle + ' a-checkoutStep--current';
      }

      if (this.props.index < this.props.currentStep) {
        return baseStyle + ' a-checkoutStep--complete';
      }

      return baseStyle;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'checkoutStep-wrapper' },
        _react2.default.createElement(
          'a',
          { styleName: this.styleName() },
          this.props.stepNumber
        ),
        _react2.default.createElement(
          'span',
          { styleName: 'checkoutStep-label' },
          this.props.stepName
        )
      );
    }
  }]);
  return ProgressBarStep;
}(_react2.default.Component), _class2.propTypes = {
  currentStep: _react.PropTypes.number.isRequired,
  stepNumber: _react.PropTypes.number.isRequired,
  numberOfSteps: _react.PropTypes.number.isRequired,
  stepName: _react.PropTypes.string.isRequired,
  index: _react.PropTypes.number.isRequired
}, _temp)) || _class);
exports.default = ProgressBarStep;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/ProgressBar/ProgressBarStep.js
// module id = 2318
// module chunks = 0